import React, { useEffect, useState, useContext } from 'react';
import { motion, useMotionValue } from 'framer-motion';
import Bg1 from '../../Assets/Skills/Background_Skills.svg';
import Elements from '../../Assets/Skills/Elements.svg';
import Persona from '../../Assets/Skills/Character.svg';
import EarthElement from '../../Assets/Skills/Earth.svg';
import SkillBar from '../../Components/SkillsBar';
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import './local.css';
import '../../index.css';

function Skills() {
    const { LNG } = useContext(DefaultContext)
    const refContainer = React.useRef(null)
    const [ready, setReady] = useState(false)
    const tiltStrength = 30; // ajuste isso conforme necessário

    const rotateX = useMotionValue(0);
    const rotateY = useMotionValue(0);

    useEffect(() => {
        const handleScroll = () => {
            const componente = refContainer.current;
            if (componente) {
                const scrollPosition = window.scrollY;

                if (700 < scrollPosition) {
                    // O ponto específico do scroll foi alcançado
                    //   console.log("Ponto específico do scroll alcançado!");
                    console.log(ready);
                    setReady(true)
                    console.log(scrollPosition);
                    // Ativar o useEffect aqui
                    // useEffectFunction();
                } else {
                    setReady(false)
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Remover o listener de evento ao desmontar o componente
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line
    }, []); // Executa apenas uma vez após a montagem do componente

    const handleMouseMove = (e) => {
        const xPos = (e.clientX / window.innerWidth - 0.2) * tiltStrength;
        const yPos = (e.clientY / window.innerHeight - 0.2) * tiltStrength;
        rotateX.set(yPos);
        rotateY.set(-xPos);
    };

    return (
        <div
            ref={refContainer}
            id='skills-container'
            onMouseMove={handleMouseMove}

        >
            <SkillBar ready={ready}></SkillBar>
            <div className='skills-section'>
                <h1 className='titleTxt skills-title'>{LNG ? ptbr.skills.item_1 : eng.skills.item_1}</h1>
                <div className='skills-art'>
                    <img
                        src={Bg1}
                        alt="Imagem"
                        className='skills-background-1'
                    />
                    <img
                        src={EarthElement}
                        alt="Imagem"
                        className='skills-earth'
                    />
                    <img
                        src={Persona}
                        alt="Imagem"
                        className='skills-persona'
                    />
                    <motion.div
                        className='skills-motion'
                        style={{
                            rotateX: rotateX,
                            rotateY: rotateY,
                        }}
                    >
                        <img
                            src={Elements}
                            alt="Imagem"
                            className='skills-motion-element'
                        />
                    </motion.div>
                </div>
            </div>
        </div >
    );
}

export default Skills;